// Shared display helpers for the season report card views.

// Grade -> color band (green great, blue good, yellow average, orange poor, red bad).
export const gradeColor = (grade: string): string => {
	const letter = grade[0];
	if (letter === "A") return "#198754";
	if (letter === "B") return "#0d6efd";
	if (letter === "C") return "#d6a300";
	if (letter === "D") return "#fd7e14";
	return "#dc3545";
};

export const CATEGORY_COLORS: Record<string, string> = {
	results: "#0d6efd",
	playoffs: "#6610f2",
	expectations: "#0dcaf0",
	development: "#198754",
	accolades: "#fd7e14",
	rebuild: "#20c997",
	capManagement: "#6c757d",
	championship: "#ffc107",
};

export const ordinal = (n: number): string => {
	const s = ["th", "st", "nd", "rd"];
	const v = n % 100;
	return n + (s[(v - 20) % 10] ?? s[v] ?? s[0]!);
};

export const playoffResult = (
	playoffRoundsWon: number,
	numPlayoffRounds: number,
): string => {
	if (playoffRoundsWon < 0) return "Missed the playoffs";
	if (playoffRoundsWon === numPlayoffRounds) return "Won the championship 🏆";
	if (playoffRoundsWon === numPlayoffRounds - 1) return "Lost in the Finals";
	if (playoffRoundsWon === numPlayoffRounds - 2)
		return "Lost in the Conference Finals";
	if (playoffRoundsWon === 0) return "Lost in the first round";
	return `Won ${playoffRoundsWon} playoff round${playoffRoundsWon > 1 ? "s" : ""}`;
};
